import { Navigate } from 'react-router-dom';
import { Ruthie } from '../components/Ruthie';
import PageTitle from '../components/PageTitle';
import { FeatureFlag, useFeatureFlagResolved } from '../services/featureFlag.service';

export default function RuthiePage() {
  // Use the loading-aware variant so we don't briefly redirect on cold load
  // before LaunchDarkly has resolved the real flag value.
  const { value: ruthieEnabled, isLoading } = useFeatureFlagResolved(FeatureFlag.RUTHIE, false);
  if (isLoading) return null;
  if (!ruthieEnabled) return <Navigate to="/" replace />;

  return (
    <div className="h-screen w-full flex flex-col">
      <div className="flex-shrink-0 p-4 border-b border-border">
        <PageTitle title="Data Architect" />
        <p className="text-sm text-muted-foreground mt-1">
          Design your semantic layer through natural conversation with Ruthie.
        </p>
      </div>
      <div className="flex-1 min-h-0 overflow-hidden">
        <Ruthie showHistory={true} />
      </div>
    </div>
  );
}
